import {useCallback, useContext} from 'react';

import {WalkthroughDefinition, WalkthroughId} from './types';
import {WalkthroughContext} from './WalkthroughContext';
import {clearWalkthroughSeen, hasSeenWalkthrough} from './walkthroughStorage';

export const useWalkthrough = () => {
  const {requestRestart} = useContext(WalkthroughContext);

  /** Force the matching `<Walkthrough id={id}>` to start from step 0. */
  const restart = useCallback(
    (id: WalkthroughId) => {
      requestRestart(id);
    },
    [requestRestart]
  );

  /** Reset the "seen" flag so the next visit triggers the auto-start. */
  const reset = useCallback((definition: WalkthroughDefinition) => {
    clearWalkthroughSeen(definition.id, definition.version);
  }, []);

  const hasSeen = useCallback(
    (definition: WalkthroughDefinition) => hasSeenWalkthrough(definition.id, definition.version),
    []
  );

  return {restart, reset, hasSeen};
};
